import React from 'react';
import { stringToBoolean } from '../../../utilities/conversionUtility';
import { interpolatePriceToTemplate, priceFormat } from '../../../utilities/helperUtility';
import DepositPrice from '../DepositPrice';
import SecurityBond from '../SecurityBond';

export default function Price(props) {
  const {
    bodyStyles, customClassName, price, settings, totalPrice, title,
  } = props;
  const { setting } = settings;
  const value = price || totalPrice;
  // eslint-disable-next-line no-prototype-builtins
  const showPrice = setting && setting.hasOwnProperty('show_price') ? stringToBoolean(setting.show_price) : true;
  const fontSize = bodyStyles.fontSize || '16px';

  if (!showPrice) return '';

  return (
    <p
      className="price-container"
      style={{
        fontSize, flexWrap: 'wrap', justifyContent: 'flex-end', display: 'flex',
      }}>
      <DepositPrice {...props} />
      <SecurityBond {...props} />
      <span
        style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}
      >
        {`${title}:`}
      </span>
      <span
        className={`ml10 ${customClassName}`}
        dangerouslySetInnerHTML={{
          __html: interpolatePriceToTemplate(priceFormat(settings), value),
        }}
      />
    </p>
  );
}
